import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLabelNameColorDict = (store: StoreSchema) =>
	store.clientLabels.clientLabelNameColorDict